import { render, staticRenderFns } from "./ModalCreateEmailActivity.vue?vue&type=template&id=63b231a8&lang=pug&"
import script from "./ModalCreateEmailActivity.vue?vue&type=script&lang=js&"
export * from "./ModalCreateEmailActivity.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateEmailActivity.vue?vue&type=style&index=0&id=63b231a8&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports